var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.result == null || _vm.result.length == 0)?_c('div',{staticClass:"p-4 text-center w-100"},[_c('h4',[_vm._v("Not Found")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }